import { render } from "./TrustImport.vue?vue&type=template&id=dc12e6f8&scoped=true"
import script from "./TrustImport.vue?vue&type=script&lang=js"
export * from "./TrustImport.vue?vue&type=script&lang=js"

import "./TrustImport.vue?vue&type=style&index=0&id=dc12e6f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc12e6f8"]])

export default __exports__